import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import {
  REQUEST_CREATE_NOTE, CANCEL_CREATE_NOTE,
  REQUEST_EDIT_NOTE, CANCEL_EDIT_NOTE,
  REQUEST_DELETE_NOTE, CANCEL_DELETE_NOTE
} from "./NotesActions";
import {
  showWindow,
  removeWindow,
  showModalWindow,
  removeModalWindow
} from "../actions/WindowActions";


function* requestCreateNote(baseAction) {
  let windowId = generateUUID();
  yield put(showWindow(windowId, "CreateNoteWindow", {kind: baseAction.kind, kindId: baseAction.kindId}, "Create Note"));
  yield take((action) => action.type === CANCEL_CREATE_NOTE && action.kind === baseAction.kind && action.kindId === baseAction.kindId);
  yield put(removeWindow(windowId));
}
function* watchRequestCreateNote() {
  yield takeLatest(REQUEST_CREATE_NOTE, requestCreateNote);
}

function* requestEditNote(baseAction) {
  let windowId = generateUUID();
  yield put(showWindow(windowId, "EditNoteWindow", {noteId: baseAction.noteId}, "Edit Note"));
  yield take((action) => 
    (action.type === CANCEL_EDIT_NOTE && action.noteId === baseAction.noteId) ||
    (action.type === REQUEST_DELETE_NOTE && action.noteId === baseAction.noteId)
  );
  yield put(removeWindow(windowId));
}
function* watchRequestEditNote() {
  yield takeLatest(REQUEST_EDIT_NOTE, requestEditNote);
}


function* requestDeleteNote(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "DeleteNoteWindow", {noteId: baseAction.noteId}, "Delete Note"));
  yield take((action) => action.type === CANCEL_DELETE_NOTE && action.noteId === baseAction.noteId);
  yield put(removeModalWindow(windowId));
}
function* watchRequestDeleteNote() {
  yield takeLatest(REQUEST_DELETE_NOTE, requestDeleteNote);
}

export default function* viewSaga() {
  yield fork(watchRequestCreateNote);
  yield fork(watchRequestEditNote);
  yield fork(watchRequestDeleteNote);
}
